import FitScreenIcon from '@mui/icons-material/FitScreen';
import { IconButton, Tooltip } from "@mui/material/node";
import { useTheme } from '@mui/material/styles';

export const FitToScreenButton = (props) => {
    const theme = useTheme();
    return (
        <Tooltip title="Fit to Screen">
        <IconButton aria-label="Fit to screen" onClick={(e) => { props.action();}} color="inherit" sx={{ m: 0.5 }}>
            <FitScreenIcon sx={{color: theme.palette.menuIcon.main}} />
        </IconButton>
        </Tooltip>
    );
}
